module.exports = __webpack_public_path__ + "94e3734c750367bd44f0825a01abe36c.svg";